import { Injectable } from '@angular/core';

import { getFirebaseBackend } from '../../authUtils';

import { User } from '../models/auth.models';

import { BehaviorSubject, Observable } from 'rxjs';

import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser$;
  user: User;

  constructor() {
    const userJson = sessionStorage.getItem('currentUser');
    this.currentUserSubject = new BehaviorSubject<User>(
      userJson ? JSON.parse(userJson) : null
    );
    this.currentUser$ = this.currentUserSubject.asObservable();
  }

  /**
   * Returns the current user
   */
  public currentUser(): User {
    return this.currentUserSubject.value;
  }

  /**
   * Performs the auth
   * @param email email of user
   * @param password password of user
   */

  login(email: string, password: string) {
    return getFirebaseBackend()
      .loginUser(email, password)
      .then((firebaseUser: any) => {
        if (!firebaseUser.emailVerified) {
          throw new Error('Please verify your email before logging in.');
        }

        console.log('Login success', firebaseUser);

        const token = firebaseUser.stsTokenManager?.accessToken;
        const user: User = {
          uid: firebaseUser.uid,
          email: firebaseUser.email,
          emailVerified: firebaseUser.emailVerified,
          isAnonymous: firebaseUser.isAnonymous,
          token: token,
          profile: 'firebase-user',
          displayName: firebaseUser.providerData?.[0]?.displayName || '',
          photoURL: firebaseUser.providerData?.[0]?.photoURL || '',
          providerId: firebaseUser.providerData?.[0]?.providerId || '',
        };

        sessionStorage.setItem('currentUser', JSON.stringify(user)); // 🔁 now using same key as fakebackend
        this.currentUserSubject.next(user);

        return user;
      })
      .catch((error) => {
        console.error('Login failed', error);
        throw error;
      });
  }

  //
  /**
   * Performs the register
   * @param email email
   * @param password password
   */
  register(email: string, password: string, username: string) {
    return getFirebaseBackend().registerUser(email, password).then((firebaseUser: any) => {

      firebase.auth().currentUser.sendEmailVerification();

      const token = firebaseUser.stsTokenManager?.accessToken;

      const user: User = {
        uid: firebaseUser.uid,
        email: firebaseUser.email,
        emailVerified: firebaseUser.emailVerified,
        isAnonymous: firebaseUser.isAnonymous,
        token: token,
        profile: 'firebase-user',
        displayName: username,
        photoURL: firebaseUser.providerData?.[0]?.photoURL || '',
        providerId: firebaseUser.providerData?.[0]?.providerId || ''
      };

      // Store and update auth state
      sessionStorage.setItem('currentUser', JSON.stringify(user));
      this.currentUserSubject.next(user);

      return user;
    });
  }

  /**
   * Reset password
   * @param email email
   */
  resetPassword(email: string) {
    return getFirebaseBackend()
      .forgetPassword(email)
      .then(() => {
        return 'Password reset email sent. Please check your inbox.';
      })
      .catch((error) => {
        throw error;
      });
  }

  /**
   * Logout the user
   */
  logout() {
    getFirebaseBackend().logout()
      .then(() => {
        sessionStorage.removeItem('currentUser');
        this.currentUserSubject.next(null);
      })
      .catch((error) => {
        console.error('Logout failed', error);
      });
  }
}
